import { z } from "zod";
import { defineWidget } from "@/lib/home/widget";

/** Links you pick, or your most visited sites. */
export default defineWidget({
  type: "kourai.links",
  version: 1,
  title: "Links",
  description: "Sites you pick, or the ones you visit most",
  sizes: ["s", "m", "l", "w", "xl"],
  defaultSize: "m",
  surfaces: ["newtab", "sidepanel"],
  data: "member",
  permissions: ["topSites"],
  config: z.object({
    /** "mine": picked by hand. "top": the browser's most visited sites. */
    source: z.enum(["mine", "top"]).default("mine"),
  }),
  load: () => import("./links-widget"),
});
